import styled from 'styled-components';
import { ArrowRight } from '@components/Icons';

const StyledArrowRight = styled(ArrowRight)`
  margin-left: ${({ theme }) => theme.spacing(4)};
  fill: ${({ theme }) => theme.colors.night_blue_1};
`;

export default StyledArrowRight;
